import { getBridgeRoot } from '../../../files/cwd/index.js';
import { commitSessionWorktrees } from '../../commit-session-worktrees.js';
import type { SessionWorktreeCache } from '../session-worktree-cache.js';

export async function commitSessionWorktree(
  cache: SessionWorktreeCache,
  params: {
    sessionId: string;
    branch: string;
    message: string;
    push: boolean;
  },
): Promise<{ ok: boolean; error?: string }> {
  const paths = cache.getRepoCheckoutPathsRef(params.sessionId);
  const targets = paths?.length ? paths : [getBridgeRoot()];
  return commitSessionWorktrees({
    paths: targets,
    branch: params.branch,
    message: params.message,
    push: params.push,
  });
}
